/**
 * @module builder
 */
import type { MoveableItem } from '../../index'

export function filterAdditional(item: MoveableItem): boolean {
  return !!item.additionalWork
}
